import ReactMarkdown from "react-markdown";

interface MarkdownProps {
  content: string;
  className?: string;
}

export const Markdown = ({ content, className = "" }: MarkdownProps) => {
  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          h1: ({ ...props }) => (
            <h1 className="mb-6 text-2xl font-bold text-foreground" {...props} />
          ),
          h2: ({ ...props }) => (
            <h2 className="mb-5 mt-10 text-xl font-bold text-foreground" {...props} />
          ),
          h3: ({ ...props }) => (
            <h3 className="mb-4 mt-8 text-lg font-bold text-foreground" {...props} />
          ),
          p: ({ ...props }) => (
            <p className="mb-5 whitespace-pre-wrap leading-loose text-foreground" {...props} />
          ),
          ul: ({ ...props }) => <ul className="mb-5 ml-6 list-disc space-y-3" {...props} />,
          ol: ({ ...props }) => <ol className="mb-5 ml-6 list-decimal space-y-3" {...props} />,
          li: ({ ...props }) => <li className="leading-relaxed text-foreground" {...props} />,
          strong: ({ ...props }) => <strong className="font-bold text-foreground" {...props} />,
          hr: () => <hr className="my-10 border-t border-border" />,
        }}
      >
        {content.replace(/\\n/g, "\n")}
      </ReactMarkdown>
    </div>
  );
};
